const routes = [
  {
    path: '/',
    component: () => import('layouts/Simple.vue'),
    children: [
      { path: '', name: 'home', component: () => import('pages/Customer.vue') },
      { path: 'pin', name: 'enterPin', component: () => import('pages/Login/Pin.vue') },
      { path: 'tables', name: 'selectUser', component: () => import('pages/Login/Tables.vue') },
      { path: 'customer', name: 'customerHome', component: () => import('pages/Customer.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/Summary.vue'),
    children: [
      { path: 'summary', name: 'orderComplete', component: () => import('pages/OrderSummary.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/Default.vue'),
    children: [
      { path: 'order', name: 'viewOrder', component: () => import('pages/Order.vue') },
      { path: 'waiter', component: () => import('pages/Waiter.vue') },
    ],
  },
  {
    path: '/menu',
    component: () => import('layouts/Default.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'viewMenu',
        component: () => import('pages/Menu.vue'),
      },
      {
        path: 'category/:categoryId',
        name: 'viewCategory',
        component: () => import('pages/Category.vue'),
      },
      {
        path: 'product/:productId/:categoryId',
        name: 'viewProduct',
        component: () => import('pages/Product.vue'),
      },
    ],
  },
  {
    path: '/error',
    component: () => import('layouts/Simple'),
    children: [
      {
        path: 'no-connection',
        name: 'errorNoConnection',
        component: () => import('pages/Error/NoConnection.vue'),
      },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error/404.vue'),
});

export default routes;
